import { useState, useEffect } from 'preact/hooks';
import { apiGet } from '../lib/api';
import { AuditLog } from '../components/AuditLog';
import { route } from 'preact-router';

interface ServerHealth {
  id: string;
  name: string;
  hostname: string;
  service_count: number;
  last_action: string | null;
}

interface HealthResponse {
  status: string;
  version: string;
  servers: ServerHealth[];
}

export function Dashboard() {
  const [health, setHealth] = useState<HealthResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadHealth();
  }, []);

  async function loadHealth() {
    try {
      const data = await apiGet<HealthResponse>('/health');
      setHealth(data);
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div class="page">
        <h1>INTEL Bot</h1>
        <p>Laden...</p>
      </div>
    );
  }

  return (
    <div class="page">
      <h1>INTEL Bot</h1>

      <div class="dashboard-servers">
        {health?.servers.map((server) => (
          <div key={server.id} class="dashboard-card">
            <div class="dashboard-card-header">
              <span class="dashboard-server-name">{server.name}</span>
              <span class="dashboard-service-count">{server.service_count} Services</span>
            </div>
            <div class="dashboard-card-meta">
              <span class="dashboard-hostname">{server.hostname}</span>
              {server.last_action && (
                <span class="dashboard-last-action">
                  Letzte Aktion: {new Date(server.last_action).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' })}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div class="dashboard-quick-actions">
        <h2>Schnellzugriff</h2>
        <div class="quick-action-grid">
          <button class="quick-action-btn" onClick={() => route('/config')}>
            <span class="quick-action-icon">⚙️</span>
            <span>Config</span>
          </button>
          <button class="quick-action-btn" onClick={() => route('/restart')}>
            <span class="quick-action-icon">🔄</span>
            <span>Restart</span>
          </button>
          <button class="quick-action-btn" onClick={() => route('/workflows')}>
            <span class="quick-action-icon">⚡</span>
            <span>Workflows</span>
          </button>
          <button class="quick-action-btn" onClick={() => route('/terminal')}>
            <span class="quick-action-icon">💻</span>
            <span>Terminal</span>
          </button>
        </div>
      </div>

      <div class="dashboard-audit">
        <h2>Letzte Aktivitäten</h2>
        <AuditLog limit={10} showFilter={false} />
      </div>
    </div>
  );
}
